import { taskApi } from "../../api/taskApi"
import { taskListSignal, taskListLoadedSignal, taskListErrorSignal } from "../signals/taskSignals"
import { taskListFiltersValueSignal } from '../signals/userSettingsSignals.js'

import { notifyException } from './notificationActions.js'

export async function fetchTaskList(businessEntityId, filter, config, accessToken) {
    taskListLoadedSignal.value = false
    taskListSignal.value = []
    return await taskApi.fetchTaskList(businessEntityId, filter, config, accessToken).then(
        (result) => {
            taskListSignal.value = result
            taskListLoadedSignal.value = true
            return result
        }
    ).catch(
        (err) => {
            taskListErrorSignal.value = err.message
        }
    )
}

export const createTask = async (businessEntityId, machinePermanentId, taskInstructions, config, accessToken) => {
    taskListLoadedSignal.value = false
    return await taskApi.createTask(businessEntityId, machinePermanentId, taskInstructions, config, accessToken).then(
        async (task) => {
            return await fetchTaskList(businessEntityId, taskListFiltersValueSignal.value, config, accessToken).then(
                () => {
                    return task
                }
            )
        }
    ).catch(
        (error) => {
            taskListErrorSignal.value = error
            throw error
        }
    )
}

export const createTasks = async (businessEntityId, taskInstructions, config, accessToken, reload = false) => {
    taskListLoadedSignal.value = false
    return await taskApi.createTasks(businessEntityId, taskInstructions, config, accessToken).then(
        async (tasks) => {
            if (reload) {
                return await fetchTaskList(businessEntityId, taskListFiltersValueSignal.value, config, accessToken).then(
                    () => {
                        return tasks
                    }
                )
            }
            return tasks
        }
    ).catch(
        (error) => {
            taskListErrorSignal.value = error
            notifyException(error, "Error creating tasks")
            throw error
        }
    )
}

export const deleteTask = async (businessEntityId, machinePermanentId, taskId, config, accessToken, reload = false) => {
    taskListLoadedSignal.value = false
    return await taskApi.deleteTask(businessEntityId, machinePermanentId, taskId, config, accessToken).then(
        async (response) => {
            if (reload) {
                return await fetchTaskList(businessEntityId, taskListFiltersValueSignal.value, config, accessToken).then(
                    () => {
                        return response
                    }
                )
            }
            return response
        }
    ).catch(
        (error) => {
            taskListErrorSignal.value = error
            throw error
        }
    )
}

export const exportTasks = async (businessEntityId, config, accessToken) => {
    return await taskApi.exportTasks(businessEntityId, config, accessToken)
}